module.exports = "uniform vec4 themingColor;\n";